import { NodeData } from "@app-utils/localStorage/localFiles";
import { useRefCallback } from "@enfusion-ui/hooks";
import { SelectOptionsType } from "@enfusion-ui/types";
import { getSelectOption } from "@enfusion-ui/utils";
import {
  Button,
  ModalActionContainer,
  Select,
  TextInput,
} from "@enfusion-ui/web-components";
import { styled } from "@enfusion-ui/web-core";
import * as React from "react";

const InputContainer = styled.div`
  display: flex;
  flex: 0 1 40%;
`;

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const RequestSaveForm: React.FC<{
  onSubmit: (name: string, directory?: NodeData) => void;
  onCancel?: () => void;
  fileName?: string;
  submitButtonText?: string;
  children?: React.ReactNode;
  requestType: string;
  nodes: Record<string, NodeData>;
}> = ({
  requestType,
  fileName = `New ${requestType} Request`,
  onSubmit,
  onCancel = () => null,
  submitButtonText = "Save",
  children,
  nodes,
}) => {
  const [loading, setLoading] = React.useState(false);
  const [nameValue, setName] = React.useState(fileName);
  const [hasNameRequiredError, setHasNameRequiredError] = React.useState(false);
  const [selectedNode, setSelectedNode] = React.useState<
    NodeData | undefined
  >();
  const directories: SelectOptionsType<string>[] = [];
  Object.values(nodes).forEach((folder: NodeData) => {
    if (!folder.file)
      directories.push({
        label: folder.name,
        value: JSON.stringify(folder),
      });
  });

  const handleSelectionChanged = useRefCallback(
    (e: { label: string; value: string } | null) => {
      if (e) {
        setSelectedNode(JSON.parse(e.value));
      }
    },
    []
  );
  const submitMiddleware = async () => {
    if (!nameValue) {
      setHasNameRequiredError(true);
      return;
    }
    setLoading(false);
    onSubmit(nameValue, selectedNode);

    setLoading(false);
  };

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setName(e.target.value);
    setHasNameRequiredError(false);
  };

  return (
    <FormContainer>
      <InputContainer>
        <TextInput
          name="name"
          label="Name"
          value={nameValue}
          onChange={handleNameChange}
          required
          errors={
            hasNameRequiredError
              ? { name: { type: "required", message: "Name is required" } }
              : undefined
          }
        />
      </InputContainer>
      <InputContainer>
        <Select
          options={directories}
          label="Directory"
          value={getSelectOption(directories, JSON.stringify(selectedNode))}
          clearable={false}
          onChange={handleSelectionChanged}
        />
      </InputContainer>
      {children}

      <ModalActionContainer style={{ marginTop: "var(--spacing-l)" }}>
        <Button primary type="submit" busy={loading} onClick={submitMiddleware}>
          {submitButtonText}
        </Button>
        <Button busy={loading} onClick={onCancel}>
          Cancel
        </Button>
      </ModalActionContainer>
    </FormContainer>
  );
};

export default RequestSaveForm;
